import type { FC } from "react";

import { noop } from "lodash";

import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { ACTIVATION_HOME_ROUTE } from "app/pages/activation/routing/constants";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";

import { ActivationComponentAssets } from "../../helpers/ActivationAssets";
import { generateAutomationName } from "../../helpers/generateAutomationName";
import { activationTracking } from "../../services/tracking";
import { MAX_TOOLTIP } from "../ActivationSetDropdown/text";

import { CREATE_ACTIVATION_SET_TEXT, ICON_NAME, ICON_SIZE } from "./const";
import * as SC from "./styles";

interface ICreateActivationSetCTA {
    currentSetsCount: number;
    ctaText?: string;
    onCtaClick?: () => void;
}

export const CreateActivationSetCTA: FC<ICreateActivationSetCTA> = ({
    currentSetsCount,
    ctaText = CREATE_ACTIVATION_SET_TEXT,
    onCtaClick,
}) => {
    const maximum = ActivationComponentAssets.activationSetsLimitation;
    const isMaxReached = currentSetsCount >= maximum;

    const onClick = () => {
        activationTracking.queryBarFilter.trackCreateActivationSetCtaClick();
        onCtaClick?.();
        proNavigator.go(ACTIVATION_HOME_ROUTE);
    };

    return (
        <SC.CreateActivationSetCTAContainer
            isDisabled={isMaxReached}
            data-automation={generateAutomationName("keyword-lists", ["query-bar", "dropdown", "footer"])}
            data-automation-disabled={isMaxReached}
        >
            <PlainTooltip
                enabled={isMaxReached}
                tooltipContent={translate(MAX_TOOLTIP)}
            >
                <div>
                    <IconButton
                        isDisabled={isMaxReached}
                        onClick={isMaxReached ? noop : onClick}
                        type={buttonTypes.FLAT}
                        iconName={ICON_NAME}
                        iconSize={ICON_SIZE}
                    >
                        {translate(ctaText)}
                    </IconButton>
                </div>
            </PlainTooltip>
        </SC.CreateActivationSetCTAContainer>
    );
};
